import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {UUID} from '../../models/uuid';
import {SessionService} from '../../../core/services/session.service';


@Component({
  selector: 'moti-team-users',
  templateUrl: './team-users.component.html',
  styleUrls: ['./team-users.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [],
})
export class TeamUsersComponent {
  @Input() teamId: UUID;
  @Input() leftAlign: boolean = false;
  @Input() small: boolean = false;
  @Input() large: boolean = false;
  @Input() showUserName: boolean = false;
  @Input() showUserEmail: boolean = false;
  @Input() showInvites: boolean = false;
  @Input() asColumn: boolean = false;
  @Input() enableAdd: boolean = true;
  @Input() enableRemove: boolean = false;
  @Input() whiteText: boolean = false;


  constructor(
    protected sess: SessionService,
  ) {
  }

}
